import { useMemo } from "react";

import { RVSideNavLayout, type PageSubNavItem } from "@regal-voice/ui";
import { usePageAvailability } from "App/routes/Hooks/usePageAvilability/usePageAvailability";
import { TOP_LEVEL_PAGES_TITLE_MAP } from "App/routes/pageNames";
import { AppPagePaths } from "App/routes/paths";
import { CollapsiblePanel } from "Utils/CollapsiblePanels";
import { useKnownPanels } from "Utils/CollapsiblePanels/knownPanels";

import { AI_AGENTS_SUB_PAGE_TITLES } from "../../agentBuilderMetadata";
import { AIAgentPaths } from "../../Pages/paths";

export function AIAgentsSubNav(): JSX.Element {
    const { aiAgentsPages } = usePageAvailability();
    const { aiAgents } = useKnownPanels();

    const settings: Array<PageSubNavItem> = useMemo(() => {
        const sett: Array<PageSubNavItem> = [
            {
                key: AIAgentPaths.templates,
                title: AI_AGENTS_SUB_PAGE_TITLES[AIAgentPaths.templates],
                href: `/${AIAgentPaths.templates}`,
                tabs: [`/${AIAgentPaths.templates}`, `/${AIAgentPaths.templates}/*`],
            },
        ];
        if (aiAgentsPages.showCustomAgents) {
            sett.push({
                key: AIAgentPaths.custom,
                title: AI_AGENTS_SUB_PAGE_TITLES[AIAgentPaths.custom],
                href: `/${AIAgentPaths.custom}`,
                tabs: [`/${AIAgentPaths.custom}`, `/${AIAgentPaths.custom}/*`],
            });
        }
        if (aiAgentsPages.showKnowledgeBase) {
            sett.push({
                key: AIAgentPaths.knowledgeBase,
                title: AI_AGENTS_SUB_PAGE_TITLES[AIAgentPaths.knowledgeBase],
                href: `/${AIAgentPaths.knowledgeBase}`,
                tabs: [`/${AIAgentPaths.knowledgeBase}`, `/${AIAgentPaths.knowledgeBase}/*`],
            });
        }
        return sett;
    }, [aiAgentsPages.showCustomAgents, aiAgentsPages.showKnowledgeBase]);

    return (
        <CollapsiblePanel panelName={aiAgents.name} expandedWidth={aiAgents.width}>
            <RVSideNavLayout
                sidenavTitle={TOP_LEVEL_PAGES_TITLE_MAP[AppPagePaths.aiAgents]}
                items={settings}
                basePath={AppPagePaths.aiAgents}
                hasSubPages
            />
        </CollapsiblePanel>
    );
}
